var _rect, _line, _line2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDailyTotalsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 348,
    height: 172,
    viewBox: "0 0 348 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 348,
    height: 172,
    rx: 7,
    fill: "#EFEFEF"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    x1: 9.47754,
    y1: 66.7709,
    x2: 338.523,
    y2: 66.7709,
    stroke: "#B1B1B1",
    strokeWidth: 0.647727
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    x1: 9.47754,
    y1: 149.676,
    x2: 338.523,
    y2: 149.676,
    stroke: "#B1B1B1",
    strokeWidth: 0.647727
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40.2944,
    y: 67.6001,
    width: 18.1364,
    height: 81.2834,
    rx: 3.5746,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 180.237,
    y: 59.457,
    width: 18.1364,
    height: 89.4281,
    rx: 3.5746,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 68.2827,
    y: 36,
    width: 18.1364,
    height: 112.884,
    rx: 3.5746,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 208.225,
    y: 36,
    width: 18.1364,
    height: 112.884,
    rx: 3.5746,
    fill: "#878787"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 96.2715,
    y: 83.0483,
    width: 18.1364,
    height: 65.8327,
    rx: 3.5746,
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 236.214,
    y: 75.0083,
    width: 18.1364,
    height: 73.8827,
    rx: 3.5746,
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 124.26,
    y: 53.0596,
    width: 18.1364,
    height: 95.821,
    rx: 3.5746,
    fill: "#D9D9D9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 264.202,
    y: 53.0596,
    width: 18.1364,
    height: 95.821,
    rx: 3.5746,
    fill: "#D9D9D9"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 152.249,
    y: 91.231,
    width: 18.1364,
    height: 57.6518,
    rx: 3.5746,
    fill: "#D9D9D9"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 292.191,
    y: 91.231,
    width: 18.1364,
    height: 57.6518,
    rx: 3.5746,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.1323 86.2978L76.9458 55.4216L107.009 103.361L133.01 86.2978L161.132 110.883L186.637 90.3604L217.514 48.9214L245.14 90.3604L270.328 68.4221L302.017 111.486",
    stroke: "#878787",
    strokeWidth: 2.59091,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.7843,
    cy: 85.8771,
    r: 2.76525,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.3512,
    cy: 54.9088,
    r: 2.76525,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.05,
    cy: 102.636,
    r: 2.76525,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 134.339,
    cy: 85.8136,
    r: 2.76525,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 161.317,
    cy: 110.755,
    r: 2.76525,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.305,
    cy: 88.4674,
    r: 2.76525,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 217.294,
    cy: 52.1446,
    r: 2.76525,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 246.693,
    cy: 85.8771,
    r: 2.76525,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 273.271,
    cy: 67.6007,
    r: 2.76525,
    fill: "white"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 302.017,
    cy: 111.008,
    r: 2.76525,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyTotalsIcon);
export default __webpack_public_path__ + "static/media/daily-totals-icon.348629229b6770ea5565f0da84d32ed0.svg";
export { ForwardRef as ReactComponent };